<template>
  <div class="page-main">
    <div class="search-container">
      <div class="search-content">
        <el-select
          v-model="platFormId"
          placeholder="全部平台"
          @change="onChangePlat"
        >
          <el-option
            v-for="item in platformList"
            :key="item.plat_id"
            :label="item.plat_name"
            :value="item.plat_id"
          />
        </el-select>
        <tlbs-input
          v-model="keyword"
          placeholder="请输入想要搜索的关键字..."
          maxlength="30"
          class="sug"
          @keyup.enter.native="onSearchDocList"
        />
        <tlbs-button
          type="primary"
          @click="onSearchDocList"
        >
          搜索
        </tlbs-button>
      </div>
      <div
        v-loading="loading"
        class="search"
      >
        <ul class="search-tab">
          <li
            v-for="item in tabList"
            :key="item.cont_id"
            class="search-tab-item"
            :class="contId === item.cont_id ? 'tab-active': ''"
            @click="onChangeTab(item.cont_id)"
          >
            <p class="search-tab-item-title">
              {{ item.cont_name }}
            </p>
            <p class="search-tab-item-num">
              {{ item.num }}
            </p>
          </li>
        </ul>
        <div>
          <ul
            v-if="docList.length > 0"
            class="search-doc"
          >
            <li
              v-for="item in docList"
              :key="item.id"
              class="search-doc-item"
            >
              <!-- eslint-disable -->
              <a
                class="search-doc-item-title"
                :href="item.url"
                target="_blank"
                v-html="item.title"
              />
              <!-- eslint-disable -->
              <p
                class="search-doc-item-txt"
                v-html="item.content"
              />
              <p
                v-if="item.source"
                class="search-doc-item-source"
              >
                <span>来源： </span><span v-html="parseDOM(item.source)"></span>
              </p>
            </li>
          </ul>
          <div
            v-if="docList.length > 0"
            class="pagination-contianer"
          >
            <tlbs-pagination
              background
              layout="prev,pager,next,jumper"
              :current-page="currentPage"
              :page-count="pageCount"
              @current-change="onChangePage"
            />
          </div>
        </div>
        <div
          v-if="isEmpty"
          class="search-empty"
        >
          <img
            class="search-empty-img"
            src="./img/pic_empty@2x.png"
          >
          <p class="search-empty-txt">
            抱歉，没有找到与 “{{ searchKeyword }}” 相关的内容
          </p>
          <p class="search-empty-tips">
            请确认搜索内容拼写正确或尝试更准确的搜索关键词
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VueJsonp from 'vue-jsonp'
// Vue.use(VueJsonp)
import httpService from '~/utils/http';
import util from '~/utils/index';
import beaconRequest from '~/utils/beaconRequest';
// 获取平台请求接口
const getConfigApi = async (param) => await httpService({
  url: '/search/conf',
  data: param,
  type: 'search'
});
// 获取文章请求接口
const getDocApi = async (param) => await httpService({
  url: '/search/list',
  data: param,
  type: 'search'
});
// 获取平台等
async function getConfigList(params) {
  try {
    const data = await getConfigApi(params);
    return data.result;
  } catch (err) {
    console.error(err);
  }
}
// 获取文章
async function getDocList(params) {
  try {
    const data = await getDocApi(params);
    return data.result;
  } catch (err) {
    console.error(err);
  }
}
export default {
  layout: 'search',
  middleware: 'handleHost',
  async asyncData({ navInit, script, userAgent }) {
    return {
      navInit,
      script,
      userAgent
    };
  },
  data() {
    return {
      platFormId: '全部平台', // 平台ID
      contId: 0, // 文章ID
      keyword: '',
      searchKeywork: '',
      pageCount: 1,
      currentPage: 1,
      loading: false,
      isEmpty: false,
      tabList: [], // tab标签列表
      docList: [], // 文章列表
      platformList: [],
    };
  },
  watch: {
    // 深度监听路由传参变化
    $route: {
      handler() {
        if (!this.$route.query.keyword) {
          return;
        };
        this.keyword = this.$route.query.keyword;
        this.currentPage = 1;
        this.getDocList({
          keyword: this.keyword,
          page: 1,
          platId: this.platFormId,
          contId: this.contId
        });
        this.onBeaconRequest();
      },
      deep: true
    }
  },
  created() {
    if (this.$route.query && this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
    };
    // 初始化获取数据
    this.getPlatformList();
  },
  mounted() {
    util.initPageComponents(this.navInit);
    this.onBeaconRequest();
  },
  methods: {
    /** 解析html字符串 */
    parseDOM(string) {
      const parser = new DOMParser();
      const text = parser.parseFromString(string, 'text/html').querySelector('body').innerText;
      return text;
    },
    onBeaconRequest() {
      beaconRequest('show_docs_search_page', { keyword: this.keyword }, this.userAgent);
    },
    // 获取列表信息
    async getPlatformList() {
      const params = {
        reqid: this.uuid(),
        timestamp: parseInt(new Date().getTime() / 1000, 10),
        key: 'BJGBZ-QDR2F-QJFJO-J2L5O-MKRFJ-FQBBF'
      };
      try {
        const res = await getConfigList(params);
        if (Array.isArray(res.datas) && res.datas.length > 0) {
          this.platformList = res.datas;
          this.platFormId = res.datas[0].plat_id;
          this.getDocList({
            keyword: this.keyword,
            page: 1,
            platId: res.datas[0].plat_id,
            contId: this.contId
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 检索数据
    onSearchDocList() {
      if (!this.keyword) {
        return;
      }
      this.$router.push({ path: '/docSearch', query: { keyword: this.keyword } });
    },
    deepClone(str) {
      return str;
    },
    // 切换平台
    onChangePlat(value) {
      this.platFormId = value;
      if (!this.keyword && this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword;
      }
      this.currentPage = 1;
      const options = {
        keyword: this.keyword,
        platId: this.platFormId,
        page: this.currentPage,
        contId: this.contId,
      };
      this.getDocList(options);
    },
    // 切换tab
    onChangeTab(id) {
      if (this.contId === id) {
        return;
      }
      if (!this.keyword && this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword;
      }
      this.contId = id;
      this.currentPage = 1;
      const options = {
        keyword: this.keyword,
        platId: this.platFormId,
        page: this.currentPage,
        contId: this.contId,
      };
      this.getDocList(options);
    },
    // 切换分页
    onChangePage(index) {
      if (!this.keyword && this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword;
      }
      const options = {
        keyword: this.keyword,
        platId: this.platFormId,
        page: index,
        contId: this.contId,
      };
      document.body.scrollTop = 0;
      this.getDocList(options);
      document.documentElement.scrollTop = 0;
    },
    // 获取文章列表方法
    async getDocList(options) {
      const params = {
        reqid: this.uuid(),
        timestamp: parseInt(new Date().getTime() / 1000, 10),
        key: 'BJGBZ-QDR2F-QJFJO-J2L5O-MKRFJ-FQBBF',
        keyword: util.HTMLEncode(options.keyword) || '',
        plat_id: options.platId || 0,
        page: options.page || 1,
        cont_id: options.contId || 0
      };
      this.loading = true;
      try {
        const res = await getDocList(params);
        this.pageCount = res.page_cnt;
        if (res && Array.isArray(res.count)) {
          this.tabList = res.count;
        }
        if (res && Array.isArray(res.datas) && res.datas.length > 0) {
          this.docList = res.datas;
          this.isEmpty = false;
        } else {
          this.docList = [];
          this.searchKeyword = options.keyword;
          this.isEmpty = true;
        }
        this.loading = false;
      } catch (error) {
        this.docList = [];
        this.tabList = [];
        this.isEmpty = true;
        this.loading = false;
        this.searchKeyword = options.keyword;
        console.error(error);
      }
    },
    uuid() {
      // uuid生成的算法 返回值为string
      const s = [];
      const hexDigits = '0123456789abcdef';
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = '4';
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] + s[18] + s[23];
      const uuid = s.join('');
      return uuid;
    }
  },
  head() {
    return {
      title: '搜索 | 腾讯位置服务',
      meta: [
        { hid: 'description', name: 'description', content: '腾讯地图开放平台为各类应用厂商和开发者提供基于腾讯地图的地理位置服务和解决方案；有针对Web应用的JavaScript API, 适合手机端Native APP的各种SDK, WebService接口和各类地图API等。' },
        { hid: 'keywords', name: 'keywords', content: '腾讯地图开放平台，腾讯地图api，qq地图，腾讯地图街景api，地图api，手机定位api，腾讯lbs，qq map api，qq地图api' }
      ],
      script: this.script
    };
  },
};

</script>

<style lang="less">
li {
  list-style:none;
}
.page-main {
    width: 100%;
    height: 100%;
    background: #F4F6F9;
    padding-top: 10px;
    .search-container {
        width: 1000px;
        margin:0 auto;
        overflow: hidden;
        box-sizing: border-box;
        background: #fff;
        padding: 30px 30px 60px;
        border-radius: 2px;
        .search-content{
          .sug{
            width: 475px;
            margin-left: -7px;
              .el-input__inner {
                height: 34px;
                line-height: 34px;
                border-radius: 0 4px 4px 0;
                &:focus {
                  border-color: #D6DAE1;
                }
                &:hover {
                  border-color: #D6DAE1;
                }
            }
          }
          .el-select {
            width: 124px;
            .el-input__inner {
              height: 34px;
              line-height: 34px;
              border-radius: 4px 0 0 4px;
              border-color: #D6DAE1;
              &:focus {
                border-color: #D6DAE1;
              }
            }
            .el-input.is-focus {
              .el-input__inner {
                border-color: #DCDFE6;
              }
            }
          }
          .el-input__suffix-inner {
            .el-icon-arrow-up {
              color:#1F2226;
              line-height: 34px;
              &::before {
                  content: "\e78f" !important;
              }
            }
          }
        }
        .search {
          min-height: 200px;
          .el-loading-spinner {
            top:200px;
          }
        }
        .search-tab {
          display: flex;
          padding: 0;
          margin-top: 30px;
          border-bottom: 1px solid #E6EAEE;
          &-item {
            display: flex;
            margin-right: 36px;
            cursor: pointer;
            &-title {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #05060A;
              height: 34px;
              line-height: 22px;
              margin-right: 8px;
            }
            &-num {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #05060A;
              background: #E6EAEE;
              border-radius: 2px;
              height: 18px;
              text-align: center;
              padding: 0 4px;
              margin-top:2px;
              line-height: 18px;
            }
          }
          .tab-active {
            .search-tab-item-title {
               font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #0062FF;
                line-height: 22px;
                border-bottom: 2px solid #0062FF;
            }


          }
        }
        .search-doc {
          padding: 0;
          &-item {
            margin-top:40px;
            &-title {
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              color: #0062FF;
              display: inline-block;
              line-height: 18px;
              em {
                color: #F8484E ;
                font-style: normal;
              }
              &:hover {
                border-bottom: 1.5px solid #0062FF;
              }
            }
            &-txt {
              margin-top: 12px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #1B202C;
              line-height: 28px;
              em {
                color: #F8484E ;
                font-style: normal;
              }
            }
            &-source {
              margin-top: 10px;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #525B6E;
              line-height: 18px;
            }
          }
        }
        .pagination-contianer {
          text-align: center;
          margin-top:60px;
        }
        .search-empty {
          padding: 127px 0 323px;
          text-align: center;
          &-img {
            width: 142px;
            height: 142px;
          }
          &-txt {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #05060A;
            text-align: center;
            line-height: 28px;
            margin-top: 20px;
          }
          &-tips {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #525B6E;
            text-align: center;
            line-height: 28px;
          }
        }
        .tlbs-button {
          width: 68px;
          min-width: 68px;
          height: 35px;
          font-size: 14px;
          padding: 0;
          margin-left: 5px;
          border-radius: 4px;
          line-height: 34px;
          background-color: #0062FF;
          border-color: #0062FF;
        }
    }
}
.el-select-dropdown {
    box-shadow: 0 5px 12px 0 rgba(41,67,102,0.10);
    border-radius: 0 0 4px 4px;
    border: none;
    .el-select-dropdown__item {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1F2226;
        padding-left: 8px;
        line-height: 34px;
        &:hover {
          background:rgba(31,34,38,0.05);
        }
    }
    .el-select-dropdown__item.hover {
      background:rgba(31,34,38,0.05);
    }
    .el-select-dropdown__item.selected {
        background: #0062FF;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 34px;
    }
    .popper__arrow {
      display: none;
    }
}
.el-popper[x-placement^=bottom] {
    margin-top: 0;
}
</style>
